"use strict";

module.exports = {
  locations: {
    carParking: {
      ABZ: 'Aberdeen',
      BHD: 'Belfast City (George Best)',
      BHX: 'Birmingham',
      BOH: 'Bournemouth',
      BRS: 'Bristol',
      CWL: 'Cardiff',
      DSA: 'Doncaster-Sheffield (Robin Hood)',
      DUB: 'Dublin',
      EMA: 'East Midlands',
      EDI: 'Edinburgh',
      EXT: 'Exeter',
      LGW: 'Gatwick',
      GLA: 'Glasgow International',
      PIK: 'Glasgow Prestwick',
      LHR: 'Heathrow',
      HUY: 'Humberside',
      INV: 'Inverness',
      LBA: 'Leeds Bradford',
      LPL: 'Liverpool',
      LCY: 'London City',
      LTN: 'Luton',
      MAN: 'Manchester',
      NCL: 'Newcastle',
      NWI: 'Norwich',
      SNN: 'Shannon',
      SOU: 'Southampton',
      SEN: 'Southend',
      STN: 'Stansted',
      MME: 'Teesside International'
    },
    hotels: {
      ABZ: 'Aberdeen',
      BHD: 'Belfast City (George Best)',
      BHX: 'Birmingham',
      BOH: 'Bournemouth',
      BRS: 'Bristol',
      CWL: 'Cardiff',
      DSA: 'Doncaster-Sheffield (Robin Hood)',
      DUB: 'Dublin',
      EMA: 'East Midlands',
      EDI: 'Edinburgh',
      EXT: 'Exeter',
      LGW: 'Gatwick',
      GLA: 'Glasgow International',
      PIK: 'Glasgow Prestwick',
      LHR: 'Heathrow',
      HUY: 'Humberside',
      LBA: 'Leeds Bradford',
      LPL: 'Liverpool',
      LCY: 'London City',
      LTN: 'Luton',
      MAN: 'Manchester',
      NCL: 'Newcastle',
      NWI: 'Norwich',
      SOU: 'Southampton',
      SEN: 'Southend',
      STN: 'Stansted',
      MME: 'Teesside International'
    },
    lounges: {
      OptGroupAirport: {
        ABZ: 'Aberdeen',
        BHD: 'Belfast City (George Best)',
        BLK: 'Blackpool',
        BHX: 'Birmingham',
        BRS: 'Bristol',
        CWL: 'Cardiff',
        DSA: 'Doncaster-Sheffield',
        DUB: 'Dublin',
        EMA: 'East Midlands',
        EDI: 'Edinburgh',
        EXT: 'Exeter',
        LGW: 'Gatwick',
        GLA: 'Glasgow International',
        PIK: 'Glasgow Prestwick',
        LHR: 'Heathrow',
        HUY: 'Humberside',
        INV: 'Inverness',
        LBA: 'Leeds Bradford',
        LPL: 'Liverpool',
        LCY: 'London City',
        LTN: 'Luton',
        MAN: 'Manchester',
        NCL: 'Newcastle',
        NWI: 'Norwich',
        SEN: 'Southend',
        STN: 'Stansted',
        MME: 'Teesside International'
      },
      OptGroupEurope: {
        ALI: 'Alicante',
        AMT: 'Amsterdam',
        ATH: 'Athens',
        BCA: 'Barcelona',
        BAS: 'Basel Switzerland',
        BSG: 'Berlin Schonefeld',
        BLO: 'Bologna',
        BRL: 'Brussels ',
        BUU: 'Budapest',
        BUL: 'Bulgaria Varna',
        CGL: 'Cologne',
        CPH: 'Copenhagen',
        DLM: 'Dalaman',
        DUT: 'Dusseldorf',
        FAR: 'Faro',
        FRK: 'Frankfurt',
        FNC: 'Funchal Madeira',
        GVL: 'Geneva',
        GBR: 'Gibraltar',
        LPA: 'Gran Canaria',
        HBG: 'Hamburg',
        HER: 'Heraklion',
        KRA: 'Krakow',
        LZA: 'Lanzarote',
        LCA: 'Larnaca',
        LIP: 'Leipzig Halle',
        LIB: 'Lisbon',
        MAE: 'Madrid',
        AGQ: 'Malaga',
        MUN: 'Munich',
        NCI: 'Nice',
        PMQ: 'Palma De Mallorca',
        PFO: 'Paphos',
        PRA: 'Prague',
        FCQ: 'Rome Fiumicino',
        SCN: 'Saarbrucken',
        EST: 'Tallinn',
        TFN: 'Tenerife',
        TRU: 'Turin',
        VLA: 'Valencia',
        ZRL: 'Zurich Switzerland'
      },
      OptGroupWorldwide: {
        AUH: 'Abu Dhabi',
        ESB: 'Ankara',
        BAJ: 'Bali',
        BKK: 'Bangkok',
        BGI: 'Barbados',
        BJV: 'Bodrum',
        CUN: 'Cancun',
        CPT: 'Capetown',
        CNX: 'Chiang Mai',
        PUJ: 'Dominican Republic Punta Cana ',
        DXB: 'Dubai',
        GAM: 'Gambia Banjul International ',
        SGN: 'Ho Chi Minh City',
        HKG: 'Hong Kong',
        IST: 'Istanbul',
        IAD: 'Izmir',
        CGK: 'Jakarta',
        BKI: 'Kota Kinabalu',
        KUL: 'Kuala Lumpur',
        MLE: 'Maldives',
        MBJ: 'Montego Bay',
        MCT: 'Muscat',
        DEL: 'New Delhi',
        AKL: 'New Zealand',
        SFB: 'Orlando Sanford',
        PEN: 'Penang',
        HKT: 'Phuket',
        POP: 'Puerto Plata Airport',
        JHB: 'Senai',
        PVG: 'Shanghai Pudong',
        SIN: 'Singapore',
        TLV: 'Tel Aviv',
        YTZ: 'Toronto',
        YVR: 'Vancouver'
      }
    },
    loungeCodes: {
      ABZ: 'Aberdeen',
      BLK: 'Blackpool',
      BHX: 'Birmingham',
      BRS: 'Bristol',
      CWL: 'Cardiff',
      EMA: 'East Midlands',
      EDI: 'Edinburgh',
      EXT: 'Exeter',
      LGW: 'Gatwick',
      GLA: 'Glasgow International',
      INV: 'Inverness',
      LHR: 'Heathrow',
      HUY: 'Humberside',
      LBA: 'Leeds Bradford',
      LPL: 'Liverpool',
      LTN: 'Luton',
      MAN: 'Manchester',
      NCL: 'Newcastle',
      SEN: 'Southend',
      STN: 'Stansted',
      MME: 'Teesside International'
    },
    fastTrack: {
      BRS: 'Bristol',
      EDI: 'Edinburgh',
      EMA: 'East Midlands',
      LBA: 'Leeds Bradford',
      MAN: 'Manchester',
      NCL: 'Newcastle',
      STN: 'Stansted'
    },
    terminals: {
      LHR: {
        'Terminal 2': '2',
        'Terminal 3': '3',
        'Terminal 4': '4',
        'Terminal 5': '5'
      },
      LGW: {
        North: 'N',
        South: 'S'
      },
      MAN: {
        'Terminal 1': '1',
        'Terminal 2': '2',
        'Terminal 3': '3'
      }
    },
    locationRedirects: {
      BFS: {
        'cp': 'https://www.holidayextras.co.uk/belfast-international-airport.html',
        'ho': 'https://www.holidayextras.co.uk/belfast-international-airport.html',
        'hcp': 'https://www.holidayextras.co.uk/belfast-international-airport.html',
        'lo': 'https://www.holidayextras.co.uk/belfast-international-airport.html'
      }
    }
  },
  RoomTypes: {
    D20: 'Double - 2 adults',
    T20: 'Twin - 2 adults',
    T11: 'Twin - 1 adult 1 child',
    S10: 'Single - 1 adult',
    T12: 'Triple - 1 adult 2 children',
    T21: 'Triple - 2 adults 1 child',
    T30: 'Triple - 3 adults',
    F13: 'Family - 1 adult 3 children',
    F22: 'Family - 2 adults 2 children',
    F23: 'Family - 2 adults 3 children',
    F31: 'Family - 3 adults 1 child',
    F32: 'Family - 3 adults 2 children'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/config/dropdowns.js
// module id = 758
// module chunks = 119